import { api } from '../../../../../utils/api/api';

export const downloadReceiptENT = async (receiptId: number) => {
  const response = await api.get(
    `payment/download_receipt_PUB?receiptId=${receiptId}`,
    {},
    {
      responseType: 'blob',
      method: 'GET',
    }
  );

  const { ok, data } = response;

  if (!ok) {
    const error = response.data;
    console.log('An error occurred.', error);
    throw error;
  }

  // @ts-ignore
  const href = URL.createObjectURL(data);

  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', 'Facture.pdf');
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
